import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
//import Select from 'react-select'
import CreatableSelect from 'react-select/creatable';

export class BLsView extends Component {
    constructor(props) {
        super(props);
        console.log("BLsView props",props)
        var rawUrl = window.location.toString();
        var vaporSemanalProveedor_Id = rawUrl.split("VaporesSemanales/")[1].split("/")[0];
        this.state = {
            operation: props.operation,
            modalState: props.modalState,
            callback: props.callback,
            toggleCallback: props.toggleCallback,
        };
        if (props.data) {
            console.log("props.data", props.data)
            props.data.fechaDeCarga = props.data.fechaDeCarga.toString().substring(0, 10)
            this.state.model = props.data
        }
        else {
            this.state.model = { nombre: "", vaporSemanalProveedor_Id };
        }
        this.state.modelValidation = {
            nombre: this.state.model.nombre != "",
        }
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000);
        this.populateData = this.populateData.bind(this);
        this.modalToggle = this.modalToggle.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
    }

    async handleChange(event) {
        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, async () => {
            
            this.validate();
        });
        
    }

    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/bls/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            var modalIsValid = !Object.keys(validations).some(function (val) {
                return validations[val] == false;
            });
            this.setState({
                modelValidation: validations,
                modalIsValid: modalIsValid
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    
    render() {
        return (
            <div >
                <Modal isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        Nuevo BLs
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Form>
                                <Row>
                                    <FormGroup className="col col-md-12">
                                        <Label for="nombre">
                                            <FormattedMessage id='Nombre' />
                                        </Label>
                                        <Input
                                            id="nombre"
                                            name="nombre"
                                            type="text"
                                            onChange={this.handleChange}
                                            value={this.state.model.fechaDeCarga}
                                            valid={this.getValidationValue(this.state.modelValidation.nombre)}
                                            invalid={!this.getValidationValue(this.state.modelValidation.nombre)}
                                        />
                                        <FormFeedback>
                                            {this.state.model.nombre == '' ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                        </FormFeedback>
                                    </FormGroup>
                                </Row>

                            </Form>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.operation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
                
            </div>
        );
    }
    componentDidMount() {
        this.populateData();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.modalState !== this.props.modalState) {
            this.setState({
                modalState: this.props.modalState
            });
        }
    }
    async populateData() {
        
    }
    modalToggle() {
        
        this.setState({
            modalState: !this.state.modalState
        }, () => { this.state.toggleCallback(); });
    }
    async modalSubmit(id) {
        console.log("modalSubmit this.state",this.state)
        if (this.state.operation == 'add') {
            this.add_modal_guardar_onclick();
        }
        
    }
    async add_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/bls', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.state.callback();
        }
        //const responceData = await response.json();
    }
}